var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunburst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .sunburst-cls-1 {\n        fill: #d0d6dc;\n      }\n\n      .sunburst-cls-2 {\n        fill: none;\n        opacity: .2;\n      }\n\n      .sunburst-cls-3 {\n        fill: #b0b7bf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2-2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "sunburst-cls-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    className: "sunburst-cls-1",
    d: "M14.44,15.15c-.55.43-1.21.71-1.94.8v7.03c2.66-.12,5.07-1.18,6.91-2.86l-4.97-4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    className: "sunburst-cls-1",
    d: "M9.56,8.85c.55-.43,1.21-.71,1.94-.8V1.03c-2.66.12-5.07,1.18-6.91,2.86l4.97,4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    className: "sunburst-cls-1",
    d: "M12.5,8.05c1.8.23,3.22,1.64,3.45,3.45h7.03c-.26-5.67-4.8-10.22-10.47-10.47v7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    className: "sunburst-cls-1",
    d: "M15.95,12.5c-.09.73-.37,1.39-.8,1.94l4.97,4.97c1.68-1.84,2.74-4.25,2.86-6.91h-7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    className: "sunburst-cls-1",
    d: "M11.5,15.95c-1.97-.25-3.5-1.91-3.5-3.95,0-.92.33-1.76.85-2.44L3.89,4.59c-1.79,1.96-2.89,4.55-2.89,7.41,0,5.91,4.66,10.71,10.5,10.97v-7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    className: "sunburst-cls-3",
    d: "M14.44,15.15c-.55.43-1.21.71-1.94.8v3.53c1.69-.11,3.23-.78,4.43-1.83l-2.49-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    className: "sunburst-cls-3",
    d: "M9.56,8.85c.55-.43,1.21-.71,1.94-.8v-3.53c-1.69.11-3.23.78-4.43,1.83l2.49,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    className: "sunburst-cls-3",
    d: "M15.95,12.5c-.09.73-.37,1.39-.8,1.94l2.49,2.49c1.05-1.2,1.72-2.74,1.83-4.43h-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    className: "sunburst-cls-3",
    d: "M11.5,15.95c-1.97-.25-3.5-1.91-3.5-3.95,0-.92.33-1.76.85-2.44l-2.49-2.49c-1.15,1.32-1.86,3.04-1.86,4.93,0,3.97,3.09,7.22,7,7.47v-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    className: "sunburst-cls-3",
    d: "M12.5,8.05c1.8.23,3.22,1.64,3.45,3.45h3.53c-.25-3.74-3.23-6.73-6.97-6.97v3.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunburst);
export default __webpack_public_path__ + "static/media/sunburst.85508ce7c6467d949f34329a5ab45021.svg";
export { ForwardRef as ReactComponent };